// src/components/Posts/Posts.tsx
import React from "react";
import Post from "./Post";

interface PostType {
  id: string;
  userId: string;
  username: string;
  content: string;
  mood?: string;
  imageUrl?: string;
  createdAt: string;
}

interface PostsProps {
  posts: PostType[];
}

const Posts: React.FC<PostsProps> = ({ posts }) => {
  const sortedPosts = [...posts].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <div className="feed">
      {sortedPosts.map((post) => (
        <Post key={post.id} post={post} />
      ))}
    </div>
  );
};

export default Posts;
